import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { ConfirmEmailNeeded, finishProviderSignIn, pendingReturn } from '../../auth/cloudSession.ts';
import { AuthFrame, ConfirmEmailPanel, SignInPanel } from '../../components/cloud/SignIn.tsx';
import { ErrorNote } from '../../components/ui.tsx';

const PROVIDER_LABEL: Record<string, string> = { google: 'Google', microsoft: 'Microsoft', github: 'GitHub', facebook: 'Facebook' };

/**
 * `/auth/callback`: the provider's way back. Checks the state, exchanges the code, and goes on; or, when the
 * provider did not vouch for the person's address, asks them to confirm one with a code first.
 */
export function AuthCallbackPage() {
  const navigate = useNavigate();
  const [error, setError] = useState<string>();
  const [confirm, setConfirm] = useState<ConfirmEmailNeeded>();
  const [choosing, setChoosing] = useState(false);
  useEffect(() => {
    const params = new URLSearchParams(location.search);
    finishProviderSignIn(params)
      .then((next) => navigate(next, { replace: true }))
      .catch((e: Error) => (e instanceof ConfirmEmailNeeded ? setConfirm(e) : setError(e.message)));
  }, [navigate]);
  if (confirm) {
    return (
      <AuthFrame title="Confirm your email">
        <ConfirmEmailPanel
          suggested={confirm.suggested}
          provider={PROVIDER_LABEL[confirm.provider] ?? 'Your provider'}
          onCancel={() => {
            setConfirm(undefined);
            setChoosing(true);
          }}
        />
      </AuthFrame>
    );
  }
  if (choosing) {
    return (
      <AuthFrame title="Sign in to Mojo Up AI Cloud">
        <SignInPanel returnTo={pendingReturn()} />
      </AuthFrame>
    );
  }
  if (!error) return <div className="flex h-full items-center justify-center text-sm text-muted">Signing in…</div>;
  return (
    <AuthFrame title="Sign in to Mojo Up AI Cloud">
      <div className="grid gap-4">
        <ErrorNote error={error} />
        <SignInPanel returnTo={pendingReturn()} />
      </div>
    </AuthFrame>
  );
}
